<template>
<div>
    <div style="width:1200px;left:0;right:0;margin:auto;">
        <img src="../../../static/home/bannerImg2Detail.jpg" alt="" style="width:100%;height:auto;">
    </div>
</div>
</template>
<script>
let that;
export default {
  data(){
      return{
       
      }
  },
  created(){
    that=this;
    that.resetSetItem('fullscreenLoading', false);
  },
methods: {
    
}
}
</script>


// WEBPACK FOOTER //
// src/pages/home/WitnessSamples.vue